import { DialogRef, DIALOG_DATA } from '@angular/cdk/dialog';
import { Component, inject } from '@angular/core';
import { ModalBaseComponent } from '../../../shared/components/modal-base/modal-base.component';
import { TranslateModule } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-unable-to-send-payment-request-modal',
  templateUrl: './unable-to-send-payment-request-modal.component.html',
  imports: [ModalBaseComponent, TranslateModule],
})
export class UnableToSendPaymentRequestModalComponent {
  protected dialogRef = inject(DialogRef);
  protected data = inject(DIALOG_DATA);
  protected router = inject(Router);

  onFixNow() {
    this.router.navigateByUrl('/billing');
    this.dialogRef.close();
  }
}
